import * as React from 'react';
import { Button, Label, FormGroup } from '../Bootstrap';
import { UploadDropzone } from '../UploadDropzone';
import { ImageIcon } from '../ImageCropModal/ImageIcon';
import './ImageUploadField.scss';

const classnames = require('classnames');

const Preview = ({ label }: { label: any }) => {
  return (
    <div className='d-flex align-items-center mb-2'>
      <ImageIcon className='image-upload-icon' /> {label}
    </div>
  );
};

interface ImageUploadFieldState {
  hasSizeError: boolean;
  hasExtensionError: boolean;
}

export class ImageUploadField extends React.Component<any, ImageUploadFieldState> {
  constructor(props) {
    super(props);

    this.state = { hasSizeError: false, hasExtensionError: false };
  }

  onChange = (file) => {
    this.setState({ hasSizeError: false, hasExtensionError: false }, () => {
      this.props.onChange(file);
    });
  };

  onSizeError = () => {
    this.setState({ hasSizeError: true });
  };

  onExtensionError = () => {
    this.setState({ hasExtensionError: true });
  };

  render() {
    let label;
    if (this.props.formData && this.props.formData.name) {
      label = <small className='me-2'>{this.props.formData.name}</small>;
    }

    const options = this.props.uiSchema['ui:options'] || {};
    const { aspectRatio } = options;
    let restrictions;
    if (options.sizeRestrictions) {
      restrictions = options.sizeRestrictions.copy;
    }

    const max = options.sizeRestrictions ? options.sizeRestrictions.max : null;
    const restrictionsClass = classnames('image-upload-restrictions', {
      'image-upload-restrictions--error': this.state.hasSizeError || this.state.hasExtensionError,
    });

    let errors;
    if (this.props.rawErrors && this.props.rawErrors.length && options.errorText) {
      errors = <div className='image-upload-errors'>{options.errorText}</div>;
    }

    return (
      <FormGroup>
        <Label>{this.props.schema.title}</Label>
        {errors}
        {label && <Preview label={label} />}
        <UploadDropzone
          onExtensionError={this.onExtensionError}
          maxSize={max}
          aspectRatio={aspectRatio}
          onChange={this.onChange}
          onSizeError={this.onSizeError}
        >
          <Button type='button' color='outline-primary' className='btn--rounded-padded'>
            Upload
          </Button>
        </UploadDropzone>
        <div className={restrictionsClass}>{restrictions}</div>
      </FormGroup>
    );
  }
}
